// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".registration-base-info-edit-icon-5ff45{margin:0 15px}.registration-base-info-selectEsg-b7aa5{width:240px!important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"edit-icon": "registration-base-info-edit-icon-5ff45",
	"editIcon": "registration-base-info-edit-icon-5ff45",
	"selectEsg": "registration-base-info-selectEsg-b7aa5"
};
export default ___CSS_LOADER_EXPORT___;
